document.addEventListener('DOMContentLoaded', function () {
	async function getReviewDataWithCache() {
		const cacheKey = 'reviewApiDataCache';
		const apiUrl = 'https://origo.bebogroep.nl/api/reviews';
		const cacheDurationInMs = 3600 * 1000 * 24; // Cache for 24 hours

		// Default data to use as a fallback if the API fails
		const fallbackData = {
			average_rating: 4.8,
			review_count: "24.553"
		};

		// Try to get data from the cache first
		const cachedItem = localStorage.getItem(cacheKey);
		if (cachedItem) {
			const {timestamp, data} = JSON.parse(cachedItem);
			// Check if the cache is still fresh
			if (Date.now() - timestamp < cacheDurationInMs) {
				return data;
			}
		}

		// If no fresh cache, fetch from the API
		try {
			const response = await fetch(apiUrl);
			if (!response.ok) {
				throw new Error(`HTTP error! Status: ${response.status}`);
			}
			const data = await response.json();

			const processedData = {
				average_rating: parseFloat(data.average_rating),

				review_count: data.total_reviews
			};

			// Save the new data and a timestamp to the cache
			const cachePayload = {
				timestamp: Date.now(),
				data: processedData
			};
			localStorage.setItem(cacheKey, JSON.stringify(cachePayload));

			return processedData;

		} catch (error) {
			return fallbackData; // On error, return the default data
		}
	}

	// Update a single badge container with data
	function updateReviewBadge(container, data) {
		if (!container) return;

		const averageRatingEl = container.querySelector('.average-rating');
		const reviewsCountEl = container.querySelector('.reviews-count');
		const starsInnerEl = container.querySelector('.stars-inner');

		if (!averageRatingEl || !reviewsCountEl || !starsInnerEl) {
			console.error("Badge elements not found in", container);
			return;
		}

		// Use comma as decimal separator for display, keep dot internally if needed
		averageRatingEl.textContent = data.average_rating;
		reviewsCountEl.textContent = `${data.review_count} reviews`;

		const totalStars = 5;
		const starPercentage = (Number(data.average_rating) / totalStars) * 100;
		starsInnerEl.style.width = `${Math.round(starPercentage / 10) * 10}%`;
	}

	function updateReviewWidget(container, data) {
		if (!container) return;

		// A full yellow star
		const fullStarSVG = google_reviews_widget_data['star_full'];

		// A half-filled star using a linear gradient
		const halfStarSVG = google_reviews_widget_data['star_half'];

		// An empty grey star
		const emptyStarSVG = google_reviews_widget_data['star_empty'];

		const averageRatingEl = container.querySelector('.rating.numbers.numbers-1 a');
		const reviewsCountEl = container.querySelector('.component.rating.total.total-1');

		if (averageRatingEl) {
			averageRatingEl.textContent = `${data.average_rating}/5`;
		}
		if (reviewsCountEl) {
			reviewsCountEl.textContent = `${data.review_count} reviews`;
		}

		// --- Add new code for stars ---
		const starElements = container.querySelectorAll('.stars span');
		const rating = data.average_rating;

		starElements.forEach((star, index) => {
			const starValue = index + 1;

			if (rating >= starValue) {
				// Full star
				star.innerHTML = fullStarSVG;
				star.setAttribute('data-value', '1');
			} else if (rating >= starValue - 0.5) {
				// Half star
				star.innerHTML = fullStarSVG;
				star.innerHTML += halfStarSVG;
				star.setAttribute('data-value', '0.5');
			} else {
				// Empty star
				star.innerHTML = emptyStarSVG;
				star.setAttribute('data-value', '0');
			}
		});
	}

	(async () => {
		const reviewData = await getReviewDataWithCache();

		// If you have multiple badges, update them all
		document.querySelectorAll('.vendor.google.reviews-badge.reviews-badge-1').forEach((badge) => {
			updateReviewBadge(badge, reviewData);
		});

		document.querySelectorAll('.vendor.google.widget.widget-1').forEach((widget) => {
			updateReviewWidget(widget, reviewData);
		});
	})();
});